import { useMemo } from "react";
// 组件
import DragHandle from "./dragHandle";
// 方法
import classNames from "classnames";
import { SortableElement } from "@yonboo/react-sortable-hoc";
// 常量
import { SortItemProps } from "../interface";

const SortItem = SortableElement((props: SortItemProps) => {
  const { item, dragHandle: wrapDragHandle } = props;
  const { render, className, style, dragHandle, } = item;
  const classes = classNames('yb-sort-item', className);
  const dragHandleRender = useMemo(() => {
    if (dragHandle === false) return null;
    if (dragHandle) {
      if (dragHandle === true) return <DragHandle />;
      return <DragHandle {...dragHandle} />;
    }
    if (!wrapDragHandle) return null;
    if (wrapDragHandle) {
      if (wrapDragHandle === true) return <DragHandle />;
      return <DragHandle {...wrapDragHandle} />;
    }
  }, [wrapDragHandle, dragHandle]);
  if (!render) return null;
  return (
    <div className={classes} style={style}>
      {dragHandleRender}
      {render}
    </div>
  );
});

export default SortItem;
